"use client";

import { Loader2 } from "lucide-react";

type PageLoadingProps = {
  variant?: "page" | "content";
};

const VARIANT_CLASS: Record<NonNullable<PageLoadingProps["variant"]>, string> = {
  page: "min-h-screen",
  content: "min-h-[calc(100vh-var(--header-height))]",
};

export const PageLoading = ({ variant = "page" }: PageLoadingProps) => (
  <div className={`flex w-full items-center justify-center ${VARIANT_CLASS[variant]}`}>
    <div className="flex items-center gap-3 text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin" />
    </div>
  </div>
);
